import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { InventoryItemOverviewFormGroup } from './inventory-item-overview-form-group.interface';
import { InventoryItemStatuses } from '../../enums/inventory-item-statuses.enum';
import { InventoryItemType } from '../../enums/inventory-item-type.enum';

@Injectable()
export class InventoryItemOverviewFormModel {
  public readonly fieldNames = {
    displayName: 'displayName',
    displayName2: 'displayName2',
    number: 'number',
    id: 'id',
    goodsCategoryId: 'goodsCategoryId',
    gtin: 'gtin',
    source: 'source',
    itemType: 'itemType',
    status: 'status',
    shortDescription: 'shortDescription',
    fullDescription: 'fullDescription',
    manufacturer: 'manufacturer',
    model: 'model',
    lastSyncDate: 'lastSyncDate',
    updatedAt: 'updatedAt',
    stock: 'stock',
    baseUnitOfMeasureId: 'baseUnitOfMeasureId',
    warehouse: 'warehouse',
    length: 'length',
    width: 'width',
    height: 'height',
    weight: 'weight',
    cubage: 'cubage',
    unitPrice: 'unitPrice',
    unitCost: 'unitCost',
    currencyCode: 'currencyCode',
    marginAmount: 'marginAmount',
    marginPercentage: 'marginPercentage',
    priceIncludesTax: 'priceIncludesTax',
  } as const;

  public readonly form: FormGroup<InventoryItemOverviewFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<InventoryItemOverviewFormGroup>({
      displayName: new FormControl('', { nonNullable: true }),
      displayName2: new FormControl('', { nonNullable: true }),
      number: new FormControl('', { nonNullable: true }),
      id: new FormControl('', { nonNullable: true }),
      goodsCategoryId: new FormControl<string | null>(null),
      gtin: new FormControl('', { nonNullable: true }),
      source: new FormControl('', { nonNullable: true }),
      itemType: new FormControl<InventoryItemType>('Product', { nonNullable: true }),
      status: new FormControl(InventoryItemStatuses.Active, { nonNullable: true }),
      shortDescription: new FormControl('', { nonNullable: true }),
      fullDescription: new FormControl('', { nonNullable: true }),
      manufacturer: new FormControl('', { nonNullable: true }),
      model: new FormControl('', { nonNullable: true }),
      lastSyncDate: new FormControl('', { nonNullable: true }),
      updatedAt: new FormControl('', { nonNullable: true }),
      stock: new FormControl('', { nonNullable: true }),
      baseUnitOfMeasureId: new FormControl<number | null>(null),
      warehouse: new FormControl('', { nonNullable: true }),
      length: new FormControl('', { nonNullable: true }),
      width: new FormControl('', { nonNullable: true }),
      height: new FormControl('', { nonNullable: true }),
      weight: new FormControl('', { nonNullable: true }),
      cubage: new FormControl('', { nonNullable: true }),
      unitPrice: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      unitCost: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      currencyCode: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      marginAmount: new FormControl('', { nonNullable: true }),
      marginPercentage: new FormControl('', { nonNullable: true }),
      priceIncludesTax: new FormControl(false, { nonNullable: true }),
    });
  }
}
